import React from 'react';
import { Button, Link, Tooltip } from '@mui/material';
import { getDetailOfDealOrCaseInCRM } from '../../helpers';

interface Props {
	dealId: number;
	isBitrixDeal: boolean;
	renderAsButton?: boolean;
	buttonLabel?: string;
	buttonSize?: 'small' | 'medium' | 'large';
	buttonVariant?: 'text' | 'outlined' | 'contained';
}

const DealOrCaseOpenDetail: React.FC<Props> = (props: Props) => {
	const {
		dealId,
		isBitrixDeal,
		renderAsButton = false,
		buttonLabel = 'Abrir',
		buttonSize = 'small',
		buttonVariant = 'outlined',
	} = props;
	const title = `Clic para abrir el ${isBitrixDeal ? 'deal de B24' : 'Caso'} en otra pestaña`;
	const href = getDetailOfDealOrCaseInCRM(dealId, isBitrixDeal);

	if (renderAsButton) {
		return (
			<Tooltip title={title}>
				<Button href={href} target="_blank" rel="noopener noreferrer" size={buttonSize} variant={buttonVariant}>
					{buttonLabel}
				</Button>
			</Tooltip>
		);
	}

	return (
		<Tooltip title={title}>
			<Link href={href} target="_blank" rel="noopener noreferrer">
				{dealId}
			</Link>
		</Tooltip>
	);
};

export default DealOrCaseOpenDetail;
